function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as r } from "./index.es33.js";
import { useRef as a, useEffect as n } from "react";
import { clsx as p } from "./index.es105.js";
import "./index.es133.js";
import { Portal as c } from "./index.es168.js";
import { ModalWrapper as l } from "./index.es207.js";
import "./index.es134.js";
import { Typography as f } from "./index.es35.js";
import "./index.es36.js";
import { useClickAway as d } from "./index.es130.js";
import e from "./index.es213.js";

var A = function A(_ref) {
  var i = _ref.title,
      t = _ref.onClose,
      _ref$isLarge = _ref.isLarge,
      s = _ref$isLarge === void 0 ? !1 : _ref$isLarge,
      m = _ref.children;
  var o = a(null);
  return d(o, t, {
    isExcludeTargets: !0
  }), n(function () {
    return window.addEventListener("popstate", t), function () {
      requestAnimationFrame(function () {
        return window.removeEventListener("popstate", t);
      });
    };
  }, []), r.jsx(l, {
    modalRef: o,
    children: r.jsx(c, {
      children: r.jsx("div", {
        className: e.overlay,
        children: r.jsxs("div", {
          className: p(e.container, _defineProperty({}, e.containerBig, s)),
          ref: o,
          children: [i && r.jsx(f.Heading7, {
            className: e.title,
            children: i
          }), m]
        })
      })
    })
  });
};

export { A as Confirm };